import {rellenarStrIzq} from './cadenas.js';
/**
 * Manejo de números. Ejemplo: generador de enteros aleatorios entre 2 enteros, conversión en numero a cadena con relleno a la izquierda.
 * @module numeros
 */
/**
 * Genera un número aleatorio entre el parametro *min* y el parametro *max*.
 *
 * @export
 * @param {int} min
 * @param {int} max
 * @returns {int}
 */
export function getRndInt(min, max) {
   return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Convierte *nro* con tantos caracteres *caracter* hasta llegar a una longitud *longitud*
 *
 * @export
 * @param {number} nro
 * @param {int} longitud
 * @param {string} [caracter='0']
 * @returns {string}
 */
export async function rellenarInt(nro, longitud, caracter = '0') {
   return rellenarStrIzq(nro.toString(), longitud, caracter);
}
/**
 * Convierte un tipo de dato numerico en una cadena con el formato establecido en las opciones.
 * @param {number} numero
 * @param {object} opciones
 * - cifrasDecimales {number} nro de cifrasDecimales decimales a mostrar.
 * - puntoDecimal {boolean} Si es __true__ se usara el punto(.) como separador decimal y coma(,) como separador de miles, caso contrario se invertiran los separadores.
 * @returns {string} cadena que representa __numero__ con el formato definido.
 */
export function formatoNumeroDecimal(
   numero,
   {cifrasDecimales = 2, puntoDecimal = true, separadorMiles = ','} = {}
) {
   let offsetRedondeo = Math.pow(10, cifrasDecimales);
   let numeroFloat = Math.round((numero + Number.EPSILON) * offsetRedondeo) / offsetRedondeo;

   if (isNaN(numeroFloat)) {
      return {
         formato: numeroFloat.toString(),
         numero: numeroFloat
      };
   }

   let formato = '';
   let separadorDecimal = '.';
   let separadorMilesChar = separadorMiles;
   if (!puntoDecimal) {
      separadorDecimal = ',';
      if (separadorMiles === ',') {
         separadorMilesChar = '.';
      }
   }
   formato = numeroFloat.toFixed(cifrasDecimales);
   if (puntoDecimal) {
      formato = formato
         .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, separadorMilesChar);
   } else {
      formato = formato
         .replace('.', ',')
         .replace(/\B(?<!,\d*)(?=(\d{3})+(?!\d))/g, separadorMilesChar);
   }
   return {
      formato,
      numero: numeroFloat
   };
}
